<template>
  <div class="modal-content fm-modal-properties">
    <div class="modal-header">
      <h5 class="modal-title">
        {{
        selectedItem.type === "file"
        ? $t("filemanager.modal.properties.file")
        : $t("filemanager.modal.properties.folder")
        }}
      </h5>
      <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body col-md-12">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-envelope"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{
            $t(`filemanager.menucontext.properties`)
            }}</span>
          </template>
            <div class="row" v-if="selectedItem.type === 'file'">
              <div class="col-12">
                {{ $t("filemanager.modal.properties.type") }}:
              </div>
            </div>
            <div class="row" v-if="selectedItem.type === 'file'">
              <div class="col-11">{{ selectedItem.document_type }}</div>
              <div class="col-1 text-right">
                <i v-on:click="copyToClipboard(selectedDisk)" :title="$t('filemanager.btn.copy')" class="far fa-copy" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ $t("filemanager.modal.properties.author") }}:
              </div>
            </div>
            <div class="row">
              <div class="col-11">{{ selectedItem.author }}</div>
              <div class="col-1 text-right">
                <i v-on:click="copyToClipboard(selectedDisk)" :title="$t('filemanager.btn.copy')" class="far fa-copy" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ $t("filemanager.modal.properties.name") }}:
              </div>
            </div>
            <div class="row">
              <div class="col-11">{{ selectedItem.basename }}</div>
              <div class="col-1 text-right">
                <i v-on:click="copyToClipboard(selectedItem.basename)" :title="$t('filemanager.btn.copy')" class="far fa-copy" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ $t("filemanager.modal.properties.path") }}:
              </div>
            </div>
            <div class="row">
              <div class="col-11">{{ selectedItem.path }}</div>
              <div class="col-1 text-right">
                <i v-on:click="copyToClipboard(selectedItem.path)" :title="$t('filemanager.btn.copy')" class="far fa-copy" />
              </div>
            </div>
            <template v-if="selectedItem.type === 'file'">
              <div class="row">
                <div class="col-12">
                  {{ $t("filemanager.modal.properties.size") }}:
                </div>
              </div>
              <div class="row">
                <div class="col-11">{{ bytesToHuman(selectedItem.size) }}</div>
                <div class="col-1 text-right">
                  <i v-on:click="copyToClipboard(bytesToHuman(selectedItem.size))" :title="$t('filemanager.btn.copy')"
                    class="far fa-copy" />
                </div>
              </div>
            </template>
            <template v-if="selectedItem.hasOwnProperty('timestamp')">
              <div class="row">
                <div class="col-12">
                  {{ $t("filemanager.modal.properties.modified") }}:
                </div>
              </div>
              <div class="row">
                <div class="col-11">
                  {{ timestampToDate(selectedItem.timestamp) }}
                </div>
                <div class="col-1 text-right">
                  <i v-on:click="
                    copyToClipboard(timestampToDate(selectedItem.timestamp))
                  " :title="$t('filemanager.btn.copy')" class="far fa-copy" />
                </div>
              </div>
            </template>
        </b-tab>
        <b-tab v-if="selectedItem.type === 'file'">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-envelope"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{
              $t("filemanager.modal.properties.version.title")
            }}</span>
          </template>
          <div v-if="is_loading">
            <center>
              <div class="din-loader mt-4 mb-4"></div>
            </center>
          </div>
          <div v-else>
            <div v-if="old_versions.length > 0">
              <table class="table table-condensed table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      {{
                        $t("filemanager.modal.properties.version.table.version")
                      }}
                    </th>
                    <!-- <th>
                      {{
                        $t("filemanager.modal.properties.version.table.comment")
                      }}
                    </th> -->
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-default">
                    <td>
                      <img
                        v-if="last_modifier.picture != null"
                        :src="load_image(last_modifier.picture_small)"
                        alt=""
                        style="border-radius: 50%"
                        width="40"
                      />
                      <img
                        v-else
                        src="@/assets/images/users/default.svg"
                        alt=""
                        style="border-radius: 8px"
                        width="40"
                      />
                    </td>
                    <td>
                      Version actuel
                      <p class="text-muted mt-2" style="font-size: 12px">
                        {{
                          $t("filemanager.modal.properties.version.modified")
                        }}
                        {{ last_modifier.firstname }}
                        {{ last_modifier.lastname }}
                      </p>
                      <b>{{ $t("filemanager.modal.properties.version.table.comment") }}</b>
                      <p>{{ actual_version.comment }}</p>
                    </td>
                    <!-- <td>{{ actual_version.comment }}</td> -->
                    <td></td>
                  </tr>
                  <tr v-for="(old_version, index) in old_versions" :key="index">
                    <td>
                      <img
                        v-if="old_version.picture != null"
                        :src="load_image(old_version.picture_small)"
                        alt=""
                        style="border-radius: 50%"
                        width="40"
                      />
                      <img
                        v-else
                        src="@/assets/images/users/default.svg"
                        alt=""
                        style="border-radius: 8px"
                        width="40"
                      />
                    </td>
                    <td>
                      {{ old_version.name }}
                      <div class="info">
                        <p class="text-muted mt-2" style="font-size: 12px">
                          {{
                            $t("filemanager.modal.properties.version.modified")
                          }}
                          {{ old_version.firstname }} {{ old_version.lastname }}
                        </p>
                        <b>{{ $t("filemanager.modal.properties.version.table.comment") }}</b>
                        <p>{{ old_version.comment }}</p>
                      </div>
                    </td>
                    <!-- <td>{{ old_version.comment }}</td> -->
                    <td class="text-right">
                       <b-dropdown
                        class="card-drop"
                        variant="white"
                        right
                        toggle-class="p-0"
                      >
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item
                          @click="download(old_version)"
                        >
                          {{ $t("pages.documents.options.download") }}
                        </b-dropdown-item>
                        <b-dropdown-item
                          @click="deleteVersion(old_version.id)"
                        >
                          {{ $t("pages.documents.options.delete") }}
                        </b-dropdown-item>
                       </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <div class="alert alert-danger">
                {{ $t("filemanager.modal.properties.version.info") }}
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import helper from "../../../router/mixins/helper";
import EventBus from "../../eventBus";
// import userApi from "../../../api/userApi";
import globalStore from "../../../state/store";

export default {
  name: "Properties",
  mixins: [modal, helper],
  data() {
    return {
      url: null,
      groups: [],
      is_admin: false,
      old_versions: [],
      actual_version: null,
      last_modifier: null,
      is_loading: false,
      gettingMetadataValues: false,
    };
  },
  computed: {
    breadcrumb() {
      return this.$store.getters[`${this.activeManager}/breadcrumb`];
    },
    /**
     * Active manager name
     * @returns {default.computed.activeManager|(function())|string|activeManager}
     */
    activeManager() {
      return this.$store.state.activeManager;
    },
    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters["selectedDisk"];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters["selectedItems"][0];
    },
    document() {
      return this.$store.getters["selectedItems"][0];
    },
    metadataValues() {
      return this.$store.state.document.metadataValues;
    },
  },
  methods: {
    /**
     * Update Users Permissions on folders and files
     *
     * @param user
     * @param dirname
     * @param value
     *
     * @return {*}
     */
    updatePermission(group, dirname, value) {
      const disk = "public";
      let formData = {
        group_id: group,
        path: dirname,
        disk: disk,
        access: value,
      };
      globalStore
        .dispatch("permissions", formData, { module: "user" })
        .then((changed) => {
          if (changed) {
            EventBus.$emit("addNotification", {
              status: "success",
              message: this.$t(
                "filemanager.modal.properties.addNotification.success"
              ),
            });
          } else {
            EventBus.$emit("addNotification", {
              status: "error",
              message: this.$t(
                "filemanager.modal.properties.addNotification.error"
              ),
            });
          }
        });
    },
    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    /**
     * Get URL
     */
    getUrl() {
      this.$store
        .dispatch("url", {
          disk: this.selectedDisk,
          path: this.selectedItem.path,
        })
        .then((response) => {
          if (response.data.result.status === "success") {
            this.url = response.data.url;
          }
        });
    },

    /**
     * Copy text to clipboard
     * @param text
     */
    copyToClipboard(text) {
      // create input
      const copyInputHelper = document.createElement("input");
      copyInputHelper.className = "copyInputHelper";
      document.body.appendChild(copyInputHelper);
      // add text
      copyInputHelper.value = text;
      copyInputHelper.select();
      // copy text to clipboard
      document.execCommand("copy");
      // clear
      document.body.removeChild(copyInputHelper);

      // Notification
      EventBus.$emit("addNotification", {
        status: "success",
        message: this.$t("filemanager.notifications.copyToClipboard"),
      });
    },

    download(old_version) {
      const disk = "public";
      const path = 'document_versions/'+old_version.path;

      this.$store
        .dispatch("getOldVersionFile", { disk, path })
        .then((response) => {
          if (response.status === 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", old_version.name);
            document.body.appendChild(fileLink);

            fileLink.click();
            this.hideModal();
          }
        })
        .catch(() => {});
    },

    deleteVersion(versionId) {
      this.$swal({
        text: this.$t("pages.documents.versions.actions.confirm"),
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t("pages.users.delete"),
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("deleteVersionOfDocument", { versionId })
            .then(() => {
              this.$swal(
                this.$t("pages.users.actions.confirm"),
                this.$t("pages.documents.versions.actions.deleted"),
                "success"
              ).then(() => {
                const index = this.old_versions.findIndex((version) => (version.id === versionId));
                this.old_versions.splice(index, 1);
              });
            });
        }
      });
    },
  },
  created() {
    // const dirname = this.selectedItem.path;
    // userApi.getAllPermissions(dirname).then((res) => {
    //   if (res.data.is_admin === 1) {
    //     this.groups = res.data.groups;
    //     this.is_admin = true;
    //   }
    // });
    const doc_id = this.document.doc_id;
    this.is_loading = true;

    this.$store
      .dispatch("oldVersions", { doc_id })
      .then((response) => {
        this.is_loading = false;
        this.old_versions = response.data.result.old_versions;
        this.actual_version = response.data.result.actual_version;
        this.last_modifier = response.data.result.last_modifier;
      })
      .catch(() => {
        this.is_loading = false;
      });
    this.gettingMetadataValues = true;
    this.$store.dispatch("documentMetadata", this.document.doc_id).then(() => {
      this.gettingMetadataValues = false;
    });
  },
};
</script>

<style lang="scss">
.fm-modal-properties .modal-body {
  .row {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;

    .fa-copy {
      padding-top: 0.2rem;
      display: none;
      cursor: pointer;
    }

    &:hover {
      background-color: #f8f9fa;

      & .fa-copy {
        display: block;
      }
    }
  }

  .col-12 {
    font-weight: bold;
    // opacity: .8;
  }

  .col-11 {
    word-wrap: break-word;
    font-size: 14px;
    margin-bottom: 14px;

  }
}
</style>
